import React, { useEffect, useCallback, useState } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import axios from 'axios';

import { auth } from '_actions/userActions';

import AdminLayout from 'layouts/Admin';
import AuthLayout from 'layouts/Auth';
import PublicLayout from 'layouts/Public';
import PublicRoute from 'hoc/PublicRoute';
import AdminRoute from 'hoc/AdminRoute';

import { silentRefresh } from 'apis/admin/userApi';
import { AuthContext } from 'context/auth';
import { setCookie, getCookie, deleteCookie } from 'lib/cookies';

function App() {
  const dispatch = useDispatch();
  const isExistingToken = getCookie('refresh');
  const [refresh, setRefresh] = useState(isExistingToken);

  const setRefreshToken = (access, refresh) => {
    setCookie('access', access, { 'max-age': 60 * 30 });
    setCookie('refresh', refresh, { 'max-age':  60 * 60 });
    setRefresh(refresh);
  };

  const onSilentRefresh = async () => {
    await silentRefresh()
      .then(onSuccess)
      .catch(error => {
        console.error('error occured in apis/admin/userApi.js - silentRefresh()', error.message);

        delete axios.defaults.headers.common['Authorization'];
        deleteCookie('access');
        deleteCookie('refresh');
      });
  };

  const onSuccess = response => {
    const { success, accessToken, refreshToken } = response.data;

    if (success) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      setRefreshToken(accessToken, refreshToken);
    }
  };

  const setting = useCallback(async () => {
    await onSilentRefresh();
    dispatch(auth());
  }, [dispatch]);

  useEffect(() => {
    setting();
  }, [setting]);

  return (
    <AuthContext.Provider value={{ refresh, setRefresh: setRefreshToken }}>
      <BrowserRouter>
        <Switch>
          <PublicRoute path="/auth" component={AuthLayout} />
          <AdminRoute path="/admin" component={AdminLayout} />
          <Route path="/" component={PublicLayout} />
        </Switch>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
